import axios from 'axios'
import security from '@/services/security.js'

export default {

  listAgendaItems (courseKey, agendaId) {
    const config = { headers: security.getAuthHeader() }
    return axios.get('/agenda-item/' + courseKey + '/' + agendaId, config)
      .then(response => {
        return response.data
      })
  },
  getParticipantAgenda (courseKey, courseScouterType, dateOf) {
    const config = { headers: security.getAuthHeader() }
    return axios.get('/agenda-item/' + courseKey + '/participant-view/' + courseScouterType + '/' + dateOf, config)
      .then(response => {
        return response.data
      })
  },
  addNewAgendaItem (courseKey, item) {
    const config = { headers: security.getAuthHeader() }
    return axios.post('/agenda-item/' + courseKey, item, config)
      .then(response => {
        return response.data
      })
  },
  updateAgendaItem (courseKey, item) {
    const config = { headers: security.getAuthHeader() }
    return axios.put('/agenda-item/' + courseKey, item, config)
      .then(response => {
        return response.data
      })
  },
  deleteAgendaItem (courseKey, agendaId, agendaItemId) {
    const config = { headers: security.getAuthHeader() }
    return axios.delete('/agenda-item/' + courseKey + '/' + agendaId + '/' + agendaItemId, config)
      .then(response => {
        return response.data
      })
  },
  updatePresenterOnItems (courseKey, presentationId, oldScouterKey, newScouterKey) {
    const config = { headers: security.getAuthHeader() }
    return axios.get('/agenda-item/' + courseKey + '/presenter/' + presentationId + '/' +
                oldScouterKey + '/' + newScouterKey, config)
      .then(response => {
        return response.data
      })
  }
}
